import React, { useState, useCallback, useRef, useEffect } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export } from 'devextreme-react/data-grid';
import LoadPanel from 'devextreme-react/load-panel';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import TextBox from 'devextreme-react/text-box';
import './CardPersonalBest.scss';

import { checkPermission } from '../../../permissions';
import { EditCellTimeComponent, EditCellTimeRender, editCellTimeRender, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { ButtonGroup, NumberBox, Button } from 'devextreme-react';
import { PerformanceCell } from '../../utils/performance-cell/PerformanceCell';
import { useScreenSize } from '../../../utils/media-query';
import { COMPETITION_STATUS_LIST, exportFormats } from '../../../shared/constants';
import { ResultDetails } from '../result-details/ResultDetails';
import { onExporting } from '../../../utils/exporter';
import axios from 'axios';
import { getApiToken } from '../../../utils/authUtils.js';
import { useMsal } from "@azure/msal-react";
import { openPDFOnDevice } from '../../../utils/pdfUtils';


const Grid = ({ data, athleteId, onImportDsvBestTimes, isdsvLoading }) => {
      const { instance, accounts } = useMsal();
    const [gridData, setGridData] = useState(data);
    const [datevisible, setdatevisible] = useState(true);
    const [cityvisible, setcityvisible] = useState(false);
    const [competitionvisible, setcompetitionvisible] = useState(false);
    const [rpvisible, setrpvisible] = useState(true);
    const [wavisible, setwavisible] = useState(false);
    const [shortcoursevisible, setshortcoursevisible] = useState(true);
    const [longcoursevisible, setlongcoursevisible] = useState(true);
    const [absolutevsibile, setabsolutevsibile] = useState(true);
    const [seasonvisible, setseasonvisible] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const selectedItemKeysCourse = ['25m', '50m'];
    const filterButtonsCourse = [{ text: '50m' }, { text: '25m' }];
    const selectedItemKeysTimeRange = ['absolut'];
    const filterButtonsTimeRange = [{ text: 'absolut' }, { text: 'saison' }];
    const selectedItemKeysFields = ['RP', 'datum'];
    const filterButtonsFields = [{ text: 'RP' }, { text: 'WA' }, { text: 'datum' }, { text: 'wettkampf' }, { text: 'stadt' }];
    const filterByButton = (e) => {
        switch (e.itemData.text) {
            case 'RP':
                setrpvisible(!rpvisible);
                break;
            case 'WA':
                setwavisible(!wavisible);
                break;
            case '25m':
                setshortcoursevisible(!shortcoursevisible);
                break;
            case '50m':
                setlongcoursevisible(!longcoursevisible);
                break;
            case 'absolut':
                setabsolutevsibile(!absolutevsibile);
                break;
            case 'saison':
                setseasonvisible(!seasonvisible);
                break;
            case 'datum':
                setdatevisible(!datevisible);
                break;
            case 'wettkampf':
                setcompetitionvisible(!competitionvisible);
                break;
            case 'stadt':
                setcityvisible(!cityvisible);
                break;
        }

    }
    const dropDownOptions = { width: 'auto' };
    const gridRef = useRef(null);
    const onPDFClick = useCallback(async () => {
        try {
            setPdfLoading(true);
            const token = await getApiToken(instance, accounts);
            const response = await axios.get(`${process.env.REACT_APP_serverEndpoint}/Athlete/ReportPBAsPdf?athleteId=${athleteId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                responseType: 'blob'
            });

            let filename = `Bestzeiten.pdf`;
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const disposition = response.headers['content-disposition'];
          
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const matches = disposition.match(/filename="?([^";]+)"?/);
                if (matches && matches[1]) {
                    filename = decodeURIComponent(matches[1]);
                }
            }

            await openPDFOnDevice(blob, filename);
        } catch (error) {
            console.error('Error downloading PDF:', error);
        } finally {
            setPdfLoading(false);
        }
    }, [athleteId, instance, accounts]);
    return (
        <div className='personalbest-card'>
            <DataGrid
                className='personalbest-grid'
                dataSource={gridData}
                remoteOperations={true}
                width={'100%'}
                height={'calc(100vh - 220px)'}
                rowAlternationEnabled={true}
                onExporting={onExporting}
                ref={gridRef}
                columnAutoWidth={true}
            //  columnAutoWidth={useScreenSize() === 'xs'}
            >
            <Export enabled formats={exportFormats} />
            <Paging enabled={false} />
            <Toolbar>
                <Item location='before' locateInMenu='auto'>
                    <ButtonGroup
                        items={filterButtonsCourse}
                        selectionMode="multiple"
                        stylingMode="text"
                        defaultSelectedItemKeys={selectedItemKeysCourse}
                        onItemClick={filterByButton}
                        cssClass='group-margin'
                    />

                    <ButtonGroup
                        items={filterButtonsTimeRange}
                        selectionMode="multiple"
                        stylingMode="text"
                        defaultSelectedItemKeys={selectedItemKeysTimeRange}
                        onItemClick={filterByButton}
                    />

                    <ButtonGroup
                        items={filterButtonsFields}
                        selectionMode="multiple"
                        stylingMode="text"
                        defaultSelectedItemKeys={selectedItemKeysFields}
                        onItemClick={filterByButton}
                    />
                </Item>
                <Item location='after' locateInMenu='auto'>
                    <Button
                        icon='exportpdf'
                        disabled={pdfLoading}
                        onClick={onPDFClick}
                    />
                </Item>
                <Item location='after' locateInMenu='auto'>
                    <Button
                        icon='import'
                        hint='DSV Bestzeiten importieren'
                        visible={checkPermission('competition.importresult')}
                        disabled={isdsvLoading}
                        onClick={onImportDsvBestTimes}
                    />
                </Item>

            </Toolbar>
            <Scrolling mode='virtual' />
            <Editing allowUpdating={false} allowAdding={false} allowDeleting={false} />

            <Column
                dataField='swimstyle_name'
                caption=''
                allowEditing={false}
                fixed={true}
                width={'100px'}
            />
            <Column caption="50m Absolut" visible={longcoursevisible && absolutevsibile} cssClass='thick-border'>
                <Column
                    dataField='swimtime_50_total'
                    caption='Zeit'
                    dataType='number'
                    cellRender={TimeBoxBold}
                    allowEditing={false}
                    cssClass='thick-border'
                    width={'120px'}
                />
                <Column
                    dataField='rp_50_total'
                    caption='RP'
                    dataType='number'
                    allowEditing={false}
                    visible={rpvisible}
                    width={'120px'}
                />
                <Column
                    dataField='wa_50_total'
                    caption='WA'
                    dataType='number'
                    allowEditing={false}
                    visible={wavisible}
                    width={'120px'}
                />
                <Column
                    dataField='date_50_total'
                    caption='Datum'
                    dataType='date'
                    allowEditing={false}
                    visible={datevisible}
                    width={'120px'}
                />
                <Column
                    dataField='competition_50_total'
                    caption='Wettkampf'
                    allowEditing={false}
                    visible={competitionvisible}
                    width={'120px'}
                />
                <Column
                    dataField='city_50_total'
                    caption='Stadt'
                    allowEditing={false}
                    visible={cityvisible}
                    width={'120px'}
                />
            </Column>
            <Column caption="50m Saison" visible={longcoursevisible && seasonvisible} cssClass='thick-border'>
                <Column
                    dataField='swimtime_50_season'
                    caption='Zeit'
                    dataType='number'
                    cellRender={TimeBoxBold}
                    allowEditing={false}
                    cssClass='thick-border'
                    width={'120px'}
                />
                <Column
                    dataField='rp_50_season'
                    caption='RP'
                    dataType='number'
                    allowEditing={false}
                    visible={rpvisible}
                    width={'120px'}
                />
                <Column
                    dataField='wa_50_season'
                    caption='WA'
                    dataType='number'
                    allowEditing={false}
                    visible={wavisible}
                    width={'120px'}
                />
                <Column
                    dataField='date_50_season'
                    caption='Datum'
                    dataType='date'
                    allowEditing={false}
                    visible={datevisible}
                    width={'120px'}
                />
                <Column
                    dataField='competition_50_season'
                    caption='Wettkampf'
                    allowEditing={false}
                    visible={competitionvisible}
                    width={'120px'}
                />
                <Column
                    dataField='city_50_season'
                    caption='Stadt'
                    allowEditing={false}
                    visible={cityvisible}
                    width={'120px'}
                />
            </Column>
            <Column caption="25m Absolut" visible={shortcoursevisible && absolutevsibile} cssClass='thick-border'>
                <Column
                    dataField='swimtime_25_total'
                    caption='Zeit'
                    dataType='number'
                    cellRender={TimeBoxBold}
                    allowEditing={false}
                    cssClass='thick-border'
                    width={'120px'}
                />
                <Column
                    dataField='rp_25_total'
                    caption='RP'
                    dataType='number'
                    allowEditing={false}
                    visible={rpvisible}
                    width={'120px'}
                />
                <Column
                    dataField='wa_25_total'
                    caption='WA'
                    dataType='number'
                    allowEditing={false}
                    visible={wavisible}
                    width={'120px'}
                />
                <Column
                    dataField='date_25_total'
                    caption='Datum'
                    dataType='date'
                    allowEditing={false}
                    visible={datevisible}
                    width={'120px'}
                />
                <Column
                    dataField='competition_25_total'
                    caption='Wettkampf'
                    allowEditing={false}
                    visible={competitionvisible}
                    width={'120px'}
                />
                <Column
                    dataField='city_25_total'
                    caption='Stadt'
                    allowEditing={false}
                    visible={cityvisible}
                    width={'120px'}
                />
            </Column>
            <Column caption="25m Saison" visible={shortcoursevisible && seasonvisible} cssClass='thick-border'>
                <Column
                    dataField='swimtime_25_season'
                    caption='Zeit'
                    dataType='number'
                    cellRender={TimeBoxBold}
                    allowEditing={false}
                    cssClass='thick-border'
                    width={'120px'}
                />
                <Column
                    dataField='rp_25_season'
                    caption='RP'
                    dataType='number'
                    allowEditing={false}
                    visible={rpvisible}
                    width={'120px'}
                />
                <Column
                    dataField='wa_25_season'
                    caption='WA'
                    dataType='number'
                    allowEditing={false}
                    visible={wavisible}
                    width={'120px'}
                />
                <Column
                    dataField='date_25_season'
                    caption='Datum'
                    dataType='date'
                    allowEditing={false}
                    visible={datevisible}
                    width={'120px'}
                />
                <Column
                    dataField='competition_25_season'
                    caption='Wettkampf'
                    allowEditing={false}
                    visible={competitionvisible}
                    width={'120px'}
                />
                <Column
                    dataField='city_25_season'
                    caption='Stadt'
                    allowEditing={false}
                    visible={cityvisible}
                    width={'120px'}
                />
            </Column >



            </DataGrid >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={pdfLoading}
                showIndicator={true}
                showPane={true}
                shading={true}
                message="PDF wird erstellt..."
                position={{ of: '.personalbest-card' }}
            />
        </div>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardPersonalBest = ({ data, isLoading, athleteId, onImportDsvBestTimes, isdsvLoading }) => {
    
    return (
        <div className='card-results'>
            <GridWithLoadPanel
                data={data}
                hasData={!!data}
                loading={isLoading}
                athleteId={athleteId}
                onImportDsvBestTimes={onImportDsvBestTimes}
                isdsvLoading={isdsvLoading}
                panelProps={{
                    container: '.card-results',
                    position: { of: '.card-results' }
                }}
            />
        </div>
    );
};


